module.exports = __webpack_public_path__ + "img/ticket.515e559f.png";